import React from "react";

// import { ReactComponent as Facebook } from 'icons/facebook.svg'
// import { ReactComponent as Twitter } from 'icons/twitter.svg'
// import { ReactComponent as Instagram } from 'icons/instagram.svg'

const Footer = () => {
  return (
    <footer className="mt-auto md:mt-0 sm:mt-0">
      {/* <div className='h-[120px] sm:h-16 bg-main flex justify-center items-center'>
				<div className='containers flex items-center md:px-10'>
					<div
						onClick={() => {
							window.open('', '_blank')
						}}
					>
						<img src='/logo-v.png' alt='logo' className='h-20 sm:hidden cursor-pointer' />
						<img src='/logo-h.png' alt='logo' className='hidden sm:block w-28 cursor-pointer' /
					</div>
					<div className='flex gap-8 ml-auto sm:gap-[16px]'>
						<div
							className='flex w-[50px] h-[50px] sm:w-8 sm:h-8 rounded-full bg-background cursor-pointer'
							onClick={() => {
								window.open('', '_blank')
							}}
						>
							<Facebook className='w-8 m-auto sm:w-6 fill-main' />
						</div>
						<div
							className='flex w-[50px] h-[50px] sm:w-8 sm:h-8 rounded-full bg-background cursor-pointer'
							onClick={() => {
								window.open('', '_blank')
							}}
						>
							<Twitter className='w-8 m-auto sm:w-6 fill-main' />
						</div>
						<div
							className='flex w-[50px] h-[50px] sm:w-8 sm:h-8 rounded-full bg-background cursor-pointer'
							onClick={() => {
								window.open('', '_blank')
							}}
						>
							<Instagram className='w-8 m-auto sm:w-6 fill-main' />
						</div>
					</div>
				</div>
			</div> */}
      <div className="bg-theme">
        <div className="containers flex h-[50px] sm:h-8">
          <span className="m-auto text-main text-[18px] sm:text-[14px] leading-[29px] font-mont select-none tracking-wider font-light">
            &copy; 2022 Max Labs, Inc. All rights reserved
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
